export function normalizeOrganizationClientIds(clientIds) {
  if (!Array.isArray(clientIds)) return []
  return [...new Set(
    clientIds
      .map((id) => String(id).trim())
      .filter((id) => id && id !== "all" && id !== "undefined" && id !== "null"),
  )].sort((left, right) => {
    const leftNum = Number(left)
    const rightNum = Number(right)
    if (Number.isFinite(leftNum) && Number.isFinite(rightNum)) return leftNum - rightNum
    return left.localeCompare(right)
  })
}

export function organizationClientIdsKey(clientIds) {
  return normalizeOrganizationClientIds(clientIds).join(",")
}

export function appendOrganizationClientIds(query, clientIds) {
  normalizeOrganizationClientIds(clientIds).forEach((id) => {
    query.append("client_ids", id)
  })
  return query
}

export function appendOrganizationBrandIds(query, brandIds) {
  normalizeOrganizationClientIds(brandIds).forEach((id) => {
    query.append("brand_ids", id)
  })
  return query
}
